import React from 'react';
import dynamic from 'next/dynamic';

import { UnsupportedSection } from 'src/components/sections/UnsupportedSection';
import { renderers } from '../../../content/renderers';
import { SerializedUISection } from '../../../types/Section';
import { PreviewErrorOverlayProps } from '../../atoms/PreviewErrorOverlay';
import * as styles from './Sections.styles';

const PreviewErrorOverlay = dynamic<PreviewErrorOverlayProps>(() =>
  import('../../atoms/PreviewErrorOverlay').then((mod) => mod.PreviewErrorOverlay),
);

interface SectionsProps {
  sections: SerializedUISection[];
  isPreview: boolean;
}

export const Sections = ({ sections, isPreview }: SectionsProps) => (
  <>
    {sections.map((section) => {
      const { sectionName, errors = [], props, uid } = section;
      const Component = renderers[sectionName] || UnsupportedSection;
      const showComponent = isPreview || !errors.some((error) => error.preventRender);
      const showPreviewErrors = isPreview && errors.length > 0;

      return (
        <section key={uid} css={styles.section} data-section-name={sectionName}>
          {showComponent && <Component {...props} />}
          {showPreviewErrors && <PreviewErrorOverlay title={sectionName} errors={errors} />}
        </section>
      );
    })}
  </>
);
